import React from 'react';

import styles from './styles.module.less';

export const AspectRatio = ({
  children,
}: {
  children: React.ReactElement;
}): JSX.Element => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>{children}</div>
    </div>
  );
};
